<div class="d-flex flex-column gap-4 transition-base">

  <!-- Main Card Container -->
  <div class="card border shadow-sm rounded-4 overflow-hidden transition-base w-100 bg-body">

    <!-- Premium Decorative Top Border Strip -->
    <div class="h-4px bg-gradient-primary w-100"></div>

    <div class="card-body p-4 p-md-5">
      <div class="d-flex flex-column gap-4">

        <!-- Profile Heading Section -->
        <div class="d-flex align-items-center gap-3 pb-3 border-bottom">

          <!-- Avatar Frame: Uses modern semantic coloring classes -->
          <div
            class="avatar-icon-wrapper rounded-circle p-3 d-flex align-items-center justify-content-center shadow-sm flex-shrink-0 bg-primary-subtle text-primary-emphasis">
            <i class="fa-regular fa-user-circle display-5"></i>
          </div>

          <!-- User Details Block -->
          <div>
            <h2 class="fw-bold mb-1 tracking-tight text-body">
              Welcome back, {{ username() }}!
            </h2>
            <div class="d-flex align-items-center gap-2 flex-wrap">
              <span
                class="badge rounded-pill px-3 py-1.5 text-uppercase fw-bold tracking-wider font-monospace shadow-sm bg-success-subtle text-success-emphasis border border-success-subtle">
                {{ login_role() }}
              </span>
              <small class="text-body-secondary">
                <i class="fa-solid fa-circle text-success me-1 system-dot" style="font-size: 0.5rem;"></i> Authorized
                Session Active
              </small>
            </div>
          </div>

        </div>

        <!-- Telephony Balance Indicator Widget -->
        @if (isBalanceAccess()) {
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4">
            <div
              class="balance-widget p-4 rounded-4 d-flex align-items-center gap-3 border shadow-sm transition-base bg-body-tertiary">

              <!-- Balance Icon Container -->
              <div
                class="p-3 rounded-3 d-flex align-items-center justify-content-center shadow-sm flex-shrink-0 bg-info-subtle text-info-emphasis">
                <i class="fa-regular fa-envelope fs-3"></i>
              </div>

              <!-- Balance Meta Content -->
              <div class="flex-grow-1">
                <div class="small fw-bold text-uppercase tracking-wider mb-1 text-body-secondary">
                  SMS Balance
                </div>
                <div class="fs-2 fw-black font-monospace tracking-tight text-primary-emphasis">
                  {{ smsbalance() | number }}
                </div>
              </div>

              <!-- Chevron -->
              <div class="text-body-secondary opacity-25 d-none d-sm-block">
                <i class="fa-solid fa-chevron-right fs-4"></i>
              </div>

            </div>
          </div>
        </div>
        }

      </div>
    </div>
  </div>
</div>